// extracted by mini-css-extract-plugin
export var lg = "_x-4";
export var md = "_x-3";
export var sm = "_x-2";
export var xs = "_x-1";
export var xxs = "_x-0";